export default __webpack_public_path__ + "static/media/logo.ac9d21f9.svg";